import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
const findMyAccountSlice = createSlice({
    name: 'findMyAccount',
    initialState,
    reducers: {
        setAccountLookupData: (state, action) => {
            state.phoneNumber = action.payload.phoneNumber;
            state.dateOfBirth = action.payload.dateOfBirth;
            state.sentToken = action.payload.sentToken;
        },
        setVerificationToken: (state, action) => {
            state.verificationToken = action.payload;
        },
        setAccountLookupResults: (state, action) => {
            state.recentApplications = action.payload.recentApplications;
            state.openAccounts = action.payload.openAccounts;
            state.pendingTransactions = action.payload.pendingTransactions;
        },
        setOpenAccounts: (state, action) => {
            state.openAccounts = action.payload;
        },
        clearAccountLookupData: (state) => {
            state.phoneNumber = undefined;
            state.dateOfBirth = undefined;
            state.sentToken = undefined;
            state.verificationToken = undefined;
            state.recentApplications = undefined;
            state.openAccounts = undefined;
            state.pendingTransactions = undefined;
        },
    },
});
export const { setAccountLookupData, setVerificationToken, setAccountLookupResults, setOpenAccounts, clearAccountLookupData, } = findMyAccountSlice.actions;
export default findMyAccountSlice.reducer;
